import { tv } from "@fanka/tailwind-variants";

export const SELECTED_MENU_CLASS_NAME = tv({
  base: "cursor-pointer p-2 flex items-center gap-2 justify-between",
  variants: {
    budgeType: {
      active: "bg-grayScale-100",
      none: "hover:bg-base-0",
    },
  },
});
